module.exports = __webpack_public_path__ + "static/img/sf-item-04.38f1d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/partnership/sf-item-04.png
// module id = iPLQ
// module chunks = 2